import { Box, Text } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { CustomTwoColumnsList } from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/CustomTwoColumnList'
import { Expensable } from 'modules/expenses/types/Expensable'

import CustomWidgetHeaderButton from './CustomWidgetHeaderButton'

interface BudgetAndProjectWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
  showWhenEmpty?: boolean
}

const buildBudgetAndProjectListData = (expensable: Expensable) => {
  const budget = expensable?.bugdetMovement?.budget?.name || ''
  const project = expensable?.projects?.[0]?.projectWorker?.imputableProject?.name || ''
  const subproject = expensable?.projects?.[0]?.subproject?.name || ''

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.budget'),
      info: budget,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.project'),
      info: project,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.subproject'),
      info: subproject,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}

const BudgetAndProjectWidget = ({
  expensable,
  editable,
  onEdit,
  showWhenEmpty,
}: BudgetAndProjectWidgetProps) => {
  const list = buildBudgetAndProjectListData(expensable)

  if (isEmpty(list)) {
    if (!showWhenEmpty) return null

    return (
      <Box gap="s16" position="relative">
        <Widget
          header={{
            title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.title'),
          }}
        >
          <Text.Normal size="200" color="grey800">
            {i18n.t('expenses_v2.confirmation_screen.not_assigned_placeholder')}
          </Text.Normal>
        </Widget>
        {editable && (
          <CustomWidgetHeaderButton
            label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
            onClick={onEdit}
          />
        )}
      </Box>
    )
  }

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.budget_and_project_block.title'),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default BudgetAndProjectWidget
